module.exports = __webpack_public_path__ + "static/media/award_survivor_mobile@2x.05bc6abd.webp";